import { render } from "./addotherdeduction.vue?vue&type=template&id=4faca6e4&scoped=true"
import script from "./addotherdeduction.vue?vue&type=script&lang=js"
export * from "./addotherdeduction.vue?vue&type=script&lang=js"

import "./addotherdeduction.vue?vue&type=style&index=0&id=4faca6e4&scoped=true&lang=css"

import exportComponent from "/home/runner/work/backoffice_jempolku_hijau/backoffice_jempolku_hijau/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4faca6e4"]])

export default __exports__